<template>
  <v-row class="mb-4" justify="center" dense>
    <v-col
      cols="4"
      lg="4"
      md="4"
      v-for="(item, index) in questTrackingDataItem"
      :key="index"
      class="pa-1"
    >
      <div style="position: relative; width: 100%; padding-top: 100%">
        <!-- disable item -->
        <v-card
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
          outlined
          rounded="lg"
          elevation="1"
          @click="openDialog(item)"
        >
          <div
            v-if="checkIsDisabled(item)"
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 2;
              background: rgba(255, 255, 255, 0.5);
              backdrop-filter: grayscale(100%) brightness(80%) contrast(120%);
              border-radius: inherit;
            "
          ></div>

          <div
            v-if="checkBgStamp(item)"
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 2;
              background: rgba(255, 255, 255, 0.5);
              border-radius: inherit;
            "
          ></div>

          <!-- stamp text -->
          <div
            v-if="displayStyle == 'stamp' && item.is_completed"
            class="justify-center align-center"
            style="
              width: 95%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-20deg); /* Center and tilt */
              text-align: center;
              border-radius: 10px;
              padding: 2px 4px;
              font-weight: bold;
              text-transform: uppercase;
              opacity: 0.9;
              z-index: 3;
              display: block;
            "
            :style="{
              color: displayStyleColor || '#f44336',
              border: '4px solid ' + (displayStyleColor || '#f44336'),
              'box-shadow':
                '0 0 0 3px ' + (displayStyleColor || '#f44336') + '4d',
              'background-color': (displayStyleColor || '#f44336') + '03',
            }"
          >
            <p
              class="ma-0 pa-0"
              style="
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
                text-align: center;
              "
            >
              {{ displayStyleText }}
            </p>
          </div>

          <!-- stamp image -->
          <v-img
            v-if="displayStyle == 'stamp_image' && item.is_completed"
            :src="
              displayStyleImage ||
              'https://www.onlygfx.com/wp-content/uploads/2017/12/ok-stamp-4-1024x1024.png'
            "
            cover
            height="80%"
            width="80%"
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 3;
              opacity: 0.9;
            "
          />

          <v-img
            :src="item.image_url"
            contain
            height="100%"
            width="100%"
            class="rounded-lg ma-auto"
            z-index="100"
          >
            <!-- Overlay title on image -->
            <div
              v-if="item.title"
              class="align-center justify-center"
              style="
                position: absolute;
                bottom: 0;
                width: 100%;
                background: rgba(0, 0, 0, 0.5);
                color: white;
                font-size: 14px;
                padding: 4px;
                text-align: center;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 1.2;
              "
            >
              {{ item.title }}
            </div>
          </v-img>
        </v-card>
      </div>
    </v-col>

    <!-- Filler columns for alignment -->
    <v-col
      v-if="
        questTrackingDataItem.length % 3 === 1 ||
        questTrackingDataItem.length % 3 === 2
      "
      cols="4"
      lg="4"
      md="4"
      class="pa-2"
    />
    <v-col
      v-if="questTrackingDataItem.length % 3 === 1"
      cols="4"
      lg="4"
      md="4"
      class="pa-2"
    />
  </v-row>
</template>

<script>
export default {
  name: "QuestTrackingDataItemNormal",
  emits: ["onOpenDialog"],
  props: {
    questTrackingData: {
      type: Array,
      required: true,
    },
    conditionSpecial: {
      type: Object,
    },
  },
  data() {
    return {
      displayStyle: null,
      displayStyleText: null,
      displayStyleImage: null,
      displayStyleColor: null,
      mode: "normal",
      isDisabled: false,
      questTrackingDataItem: [],
    };
  },
  mounted() {
    if (this.conditionSpecial != null) {
      this.displayStyle = this.conditionSpecial.completion_display_style;
      this.displayStyleText =
        this.conditionSpecial.completion_display_text ?? "success";
      this.displayStyleImage =
        this.conditionSpecial.completion_display_image_url ??
        "https://www.onlygfx.com/wp-content/uploads/2017/12/ok-stamp-4-1024x1024.png";
      this.displayStyleColor = this.conditionSpecial.completion_display_color;
      this.mode = this.conditionSpecial.mode ?? "normal";
    } else {
      this.displayStyle = "disable";
    }

    // ========== ========== ========== ==========
    const _questTrackingData = [...this.questTrackingData];
    this.questTrackingDataItem = _questTrackingData;

    // ========== ========== ========== ==========
    if (this.displayStyle === "hidden") {
      this.questTrackingDataItem = this.questTrackingDataItem.filter(
        (item) => !item.is_completed
      );
    }
  },
  methods: {
    openDialog(item) {
      const selectItem = {
        ...item,
        mode: this.mode,
      };
      this.$emit("onOpenDialog", selectItem);
    },
    checkBgStamp(item) {
      if (this.displayStyle == "stamp" || this.displayStyle == "stamp_image") {
        if (item.is_completed) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    checkIsDisabled(item) {
      if (this.displayStyle == "highlight") {
        if (item.is_completed) {
          return false;
        } else {
          return true;
        }
      } else if (this.displayStyle == "disable") {
        if (item.is_completed) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  filters: {},
};
</script>

<style scoped>
</style>